import type { ReasoningRow } from '../../meta/types';

/** `**Interpreting the overview**\n\nI'm trying…` → heading and body. */
export function splitThought(thought: string): {
  heading: string;
  body: string;
} {
  const match = /^\s*\*\*(.+?)\*\*\s*/.exec(thought);
  if (!match) {
    return { heading: '', body: thought };
  }
  return {
    heading: match[1]?.trim() ?? '',
    body: thought.slice(match[0].length).trim(),
  };
}

/** A tool still marked running when the stream closed will never finish, so
 *  it shows as failed rather than spinning forever. */
export function settleRunningTools(rows: ReasoningRow[]): ReasoningRow[] {
  return rows.map((row) =>
    row.kind === 'tool' && row.status === 'running'
      ? { ...row, status: 'error' as const }
      : row
  );
}
